module.exports = __webpack_public_path__ + "media/images/products-img-01-c31ab1dafe404da0e778969e13de5174.png";